import styled from 'styled-components';

const BoardApprovalStyles = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem;
  overflow-x: auto;
  fieldset {
    grid-column: span 2;
    overflow-x: auto;
  }
`;

export default BoardApprovalStyles;
